module.exports = __webpack_public_path__ + "images/emoji/swimmer.dab7efc5bc11a961e814.png";